var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "concept-taxes" },
    [
      _c("h5", { staticClass: "title is-5" }, [
        _vm._v("\n    Documentos Relacionados\n  ")
      ]),
      _c(
        "BTooltip",
        { attrs: { label: "Agregar partida", type: "is-success" } },
        [
          !_vm.disabled
            ? _c(
                "a",
                {
                  staticClass: "button add-concept is-success is-rounded",
                  on: { click: _vm.addRow }
                },
                [
                  _c("BIcon", { attrs: { icon: "plus" } }),
                  _c("span", [
                    _vm._v("\n         \n        Agregar Documento\n      ")
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c("div", { staticClass: "detail-title-container mt-2" }, [
        !_vm.disabled
          ? _c(
              "div",
              { staticClass: "is-centered is-12" },
              [
                _c(
                  "BTable",
                  {
                    attrs: {
                      data: _vm.fixedDocumentsRelated,
                      columns: _vm.columns
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(props) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    "header-label": props.column.label === "SKU"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.column.label) +
                                      "\n          "
                                  )
                                ]
                              ),
                              props.column.meta
                                ? _c("AppTooltip", {
                                    attrs: { label: props.column.meta }
                                  })
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "BTableColumn",
                                {
                                  staticClass: "limit-300",
                                  attrs: { field: "search", internal: "" }
                                },
                                [
                                  _c("Searcher", {
                                    attrs: {
                                      id: "documentId",
                                      name: "documentId",
                                      required: true,
                                      "invoice-id": props.row.documentId
                                    },
                                    on: {
                                      selected: function($event) {
                                        return _vm.setInvoiceValues(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                {
                                  attrs: { field: "partiality", internal: "" }
                                },
                                [
                                  _c("AppInputField", {
                                    attrs: {
                                      name: "documentPartialityNumber",
                                      placeholder: "1",
                                      min: "0.01",
                                      step: "0.01",
                                      type: "number",
                                      disabled: _vm.loading || _vm.disabled,
                                      value: props.row.documentPartialityNumber,
                                      required: true
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                { attrs: { field: "currency", internal: "" } },
                                [
                                  _c("AppInputField", {
                                    attrs: {
                                      name: "documentCurrency",
                                      value: props.row.documentCurrency,
                                      disabled: "",
                                      required: true
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                { attrs: { field: "amount", internal: "" } },
                                [
                                  _c("AppInputField", {
                                    attrs: {
                                      name: "documentPreviousBalance",
                                      placeholder: "1",
                                      min: "0.01",
                                      step: "0.01",
                                      type: "number",
                                      disabled: _vm.loading || _vm.disabled,
                                      value: props.row.documentPreviousBalance,
                                      required: true
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                {
                                  attrs: { field: "amountPaid", internal: "" }
                                },
                                [
                                  _c("AppInputField", {
                                    attrs: {
                                      name: "documentAmountPaid",
                                      placeholder: "1",
                                      min: "0.01",
                                      step: "0.01",
                                      type: "number",
                                      disabled: _vm.loading || _vm.disabled,
                                      value: props.row.documentAmountPaid,
                                      required: true
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                {
                                  attrs: {
                                    field: "OutstandingBalance",
                                    internal: ""
                                  }
                                },
                                [
                                  _c("AppInputField", {
                                    attrs: {
                                      name: "documentOutstandingBalance",
                                      placeholder: "1",
                                      type: "number",
                                      step: "0.01",
                                      min: "0.00",
                                      max: String(
                                        props.row.documentPreviousBalance
                                      ),
                                      disabled: _vm.loading || _vm.disabled,
                                      value: _vm.calc(props.row),
                                      required: true
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChange(
                                          $event,
                                          props.row.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "BTableColumn",
                                { attrs: { field: "actions", internal: "" } },
                                [
                                  _c("span", { staticClass: "actions" }, [
                                    _vm.documents.length > 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "button is-danger",
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteRow(
                                                  props.row.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("BIcon", {
                                              attrs: {
                                                icon: "delete",
                                                "aria-hidden": "true"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4216464933
                    )
                  },
                  [
                    _c("template", { slot: "footer" }, [
                      _c("th", { attrs: { colspan: "3" } }),
                      _c("th", [_vm._v("\n            Total\n          ")]),
                      _c("th", [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.total()) +
                              "\n            "
                          )
                        ])
                      ]),
                      _c("th")
                    ])
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "wrapper-invoice-totals" },
          [
            _c(
              "BTable",
              [
                _c("template", { slot: "footer" }, [
                  _c("div", { staticClass: "totals" }, [
                    _c("tr", [
                      _c("th", { attrs: { scope: "col", colspan: "1" } }),
                      _c(
                        "th",
                        {
                          staticClass: "has-text-right",
                          attrs: { scope: "col" }
                        },
                        [_vm._v("\n                Impuestos\n              ")]
                      ),
                      _c("th", { attrs: { scope: "col" } }, [
                        _c("span", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.totalTaxesTransfers()) +
                              "\n                "
                          )
                        ])
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { scope: "col", colspan: "1" } }),
                      _c(
                        "th",
                        {
                          staticClass: "has-text-right",
                          attrs: { scope: "col" }
                        },
                        [
                          _vm._v(
                            "\n                Retenciones\n              "
                          )
                        ]
                      ),
                      _c("th", { attrs: { scope: "col" } }, [
                        _c("span", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.totalTaxesRetained()) +
                              "\n                "
                          )
                        ])
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { scope: "col", colspan: "1" } }),
                      _c(
                        "th",
                        {
                          staticClass: "has-text-right",
                          attrs: { scope: "col" }
                        },
                        [_vm._v("\n                Total\n              ")]
                      ),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.total()) +
                            "\n              "
                        )
                      ])
                    ])
                  ])
                ])
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }